export const MS_AUTHENTICATE = '/msauthenticate';
